import { render, staticRenderFns } from "./supervisorReview.vue?vue&type=template&id=4d83cec6&scoped=true"
import script from "./supervisorReview.vue?vue&type=script&lang=js"
export * from "./supervisorReview.vue?vue&type=script&lang=js"
import style0 from "./supervisorReview.vue?vue&type=style&index=0&id=4d83cec6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d83cec6",
  null
  
)

export default component.exports